<template lang="pug">
	v-container(fluid class=" tw-w-full tw-h-full ")
		v-row(dense class=" tw-bg-white tw-rounded-md tw-mx-4 tw-h-full")
			v-col()
				template(v-if="error == 0")
					| No Error
				template(v-if="error == 404")
					v-row(justify="center")
						v-col(cols="auto")
							div(class="tw-pt-10 tw-pb-6 tw-text-4xl tw-font-bold tw-text-blueGray-lighten-2")
								span() Ooops! We couldn't find what you were looking for
					v-row(justify="center" align="end")
						v-col(cols="11" )
							v-lottie-player(
								:loop="true"
								width="100%"
								height="100%"  
								:animation-data="require('@/assets/animations/404-not-found.json')"
							)
</template>
<script>
export default {
	computed:{
		error(){
			if(this.$store.getters['error']){
				return this.$store.getters['error'].response.status
			}else{
				return 0
			}
		}
	},
	created() {
		this.$store.commit('displaySidebar', false)
		this.$store.commit('displayWebsiteToolbar', false)
		this.$store.commit('displayMainToolbar', true)
    }
}
</script>